import styled from '@emotion/styled';
import type { SelectSize, SelectVariant } from './types';

type StyledSelectProps = {
  $variant: SelectVariant;
  $size: SelectSize;
  $hasError?: boolean;
  $fullWidth?: boolean;
};

export const StyledSelect = styled.select<StyledSelectProps>`
  box-sizing: border-box;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  font-family: inherit;
  cursor: pointer;
  outline: none;
  appearance: auto;
  transition: border-color 0.2s ease;
  border-radius: ${({ theme }) =>
    theme?.component?.select?.borderRadius ?? theme?.radius?.regular ?? '8px'};
  font-size: ${({ theme, $size }) =>
    theme?.component?.select?.size?.[$size]?.fontSize ?? '1rem'};
  padding: ${({ theme, $size }) =>
    theme?.component?.select?.size?.[$size]?.padding ?? '1rem'};
  min-height: ${({ theme, $size }) =>
    theme?.component?.select?.size?.[$size]?.minHeight ?? '48px'};
  background-color: ${({ theme, $variant }) =>
    theme?.component?.select?.[$variant]?.backgroundColor ?? '#ffffff'};
  color: ${({ theme, $variant }) =>
    theme?.component?.select?.[$variant]?.color ?? theme?.colors?.text?.primary};
  font-weight: ${({ theme, $variant }) =>
    theme?.component?.select?.[$variant]?.fontWeight ?? 'inherit'};
  border: 1px solid
    ${({ theme, $variant, $hasError }) =>
      $hasError
        ? theme?.component?.input?.default?.errorBorderColor ?? '#d32f2f'
        : theme?.component?.select?.[$variant]?.borderColor ??
          theme?.colors?.border?.color};

  &:focus {
    border-color: ${({ theme, $variant, $hasError }) =>
      $hasError
        ? theme?.component?.input?.default?.errorBorderColor ?? '#d32f2f'
        : theme?.component?.select?.[$variant]?.focusBorderColor ??
          theme?.colors?.text?.primary};
  }

  &:disabled {
    opacity: ${({ theme, $variant }) =>
      theme?.component?.select?.[$variant]?.disabledOpacity ?? 0.6};
    cursor: not-allowed;
  }
`;
